import React from 'react';
import NewChatButton from './NewChatButton';
import ExpandChatButton from './ExpandChatButton';
import ModelSelector from './ModelSelector';
import ActiveModelName from './ActiveModelName';
import { useChatWidgetContext } from '../../ChatWidgetContext';
import { useLlmDebugFlag } from '../../useLlmDebugFlag';
import styles from '../ChatWidget.module.scss';
import nekstAiIcon from './nekstAiIcon.png';

interface ChatHeaderProps {
  onClose: () => void;
  onExpand: (conversationId: number | null) => void;
}

function HeaderSubtitle() {
  const { currentConversationId } = useChatWidgetContext();
  const isDebugEnabled = useLlmDebugFlag();

  if (!isDebugEnabled) {
    return <div className={styles.headerSubtitle}>Online</div>;
  }

  if (currentConversationId === null) {
    return <ModelSelector />;
  } else {
    return <ActiveModelName />;
  }
}

export default function ChatHeader(props: ChatHeaderProps) {
  return (
    <div className={styles.header} data-testid="chat-header">
      <div className={styles.headerInfo}>
        <div className={styles.headerAvatar}>
          <img src={nekstAiIcon} alt="Nekst AI" width={32} height={32} />
        </div>
        <div className={styles.headerText}>
          <div className={styles.headerTitle}>Nekst AI</div>
          <HeaderSubtitle />
        </div>
      </div>
      <div className={styles.headerActions}>
        <NewChatButton />
        <ExpandChatButton onExpand={props.onExpand} />
        <button
          type="button"
          className={styles.headerButton}
          onClick={props.onClose}
          aria-label="Close chat"
        >
          &times;
        </button>
      </div>
    </div>
  );
}
